import { render } from "./JudgeDetailResult.vue?vue&type=template&id=2f10cc0c&scoped=true&ts=true"
import script from "./JudgeDetailResult.vue?vue&type=script&lang=ts"
export * from "./JudgeDetailResult.vue?vue&type=script&lang=ts"

import "./JudgeDetailResult.vue?vue&type=style&index=0&id=2f10cc0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f10cc0c"]])

export default __exports__